
import { defineComponent } from 'vue';
import { ErrorCode } from '@/modules/common/enums/error-codes.enum';

export default defineComponent({
  name: 'LmsPortalError',
  props: {
    error: {
      type: Object as () => {
        error_message?: string;
        error_code?: string;
        errors?: { [key: string]: Array<string> };
      } | null,
      required: false,
      default: null
    },
    event_identifier: {
      type: String,
      required: false
    }
  },
  computed: {
    message(): string {
      return this.error?.error_message ?? 'There was an error';
    },
    error_code(): string | undefined {
      return this.error?.error_code;
    },
    unauthorized(): boolean {
      return this.error_code !== undefined && [
        ErrorCode.INVALID_SIGNATURE,
        ErrorCode.SECRET_NOT_CONFIGURED,
        ErrorCode.MISSING_SIGNATURE
      ].includes(this.error_code as ErrorCode);
    }
  }
});
